module.exports = __webpack_public_path__ + "static/media/599.7554 (2).3ee2d5e4.pdf";